module.exports = __webpack_public_path__ + "static/media/otp_sent.9ded37bc.png";